<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>HISTORY.TITLE</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && !hasHistoryEntries">
    <div class="no-entries-label" translate>HISTORY.NO_ENTRIES</div>
  </ng-template>

  <ng-template [ngIf]="hasHistoryEntries">
    <!--ion-virtual-scroll [items]="historyEntries" approxItemHeight="600px">
      <ion-item *virtualItem="let historyEntry; let i = index" class="item-block history-item-container">

        <div class="item-inner history-item">
          <div class="date-label">{{getLocalizedDate(historyEntry.date)}}</div>

          <div class="dialog-or-tip" *ngFor="let item of historyEntry.items; let j = index" (click)="interceptClick($event)">
            <iframe *ngIf="audioUrl[i*100+j] != null" class="player" name= "player" [src]="audioUrl[i*100+j]">
            </iframe>
            <iframe *ngIf="videoUrl[i*100+j] != null" class="video" name="vplayer" [src]="videoUrl[i*100+j]" frameborder="0" allow="accelerometer; encrypted-media; gyroscope;" allowfullscreen>
            </iframe>
            <div class="markdown-description" [innerHTML]="getLocalizedHistoryEntryDescription(item.description, i*100+j)"></div>
            <div>

              <div class="dialog" *ngIf="item.type === 'dialogAnswer'">
                <div class="dialog-answer" *ngFor="let answer of item.answers">

                  <div class="question-text">{{getLocalizedHistoryEntryTitle(answer.text)}}</div>

                  <scale-question *ngIf="answer.responseType === '1'" [value]="answer.response" [valueOnly]="true" [minLabel]="getMinLabel(answer)" [maxLabel]="getMaxLabel(answer)"
                    class="history-result"></scale-question>
                  <likert-question *ngIf="answer.responseType === '2'" [value]="answer.response" [valueOnly]="true" [minLabel]="getMinLabel(answer)" [maxLabel]="getMaxLabel(answer)"
                    class="history-result"></likert-question>
                  <yes-no-question *ngIf="answer.responseType === '3'" [value]="answer.response" [valueOnly]="true"
                    class="history-result"></yes-no-question>
                  <text-question *ngIf="answer.responseType === '4'" [value]="answer.response" [valueOnly]="true"
                    class="history-result"></text-question>
                  <mc-question *ngIf="answer.responseType === '5'" [value]="answer.response" [valueOnly]="true" [options]="answer.options"
                    class="history-result"></mc-question>

                </div>
              </div>

              <div class="tip" *ngIf="item.type === 'tipRating'">
                <div class="question-text" [innerHTML]="getLocalizedHistoryEntryDescription(item.text, i*100+j)"></div>
                <rating [value]="item.response"></rating>
              </div>

            </div>
          </div>
        </div>

      </ion-item>
    </ion-virtual-scroll-->
  </ng-template>

</ion-content>
